import { ClientStatus, Markdown } from "../../../index";

type OAuthConfig = {
	authUrl: string;
	tokenUrl: string;
	scopes: string[];
	clientId?: string;
	redirectUri?: string;
};

type ClientProps = {
	id: string;
	slug: string;
	displayName: string;
	description: Markdown;
	logoUrl?: string;
	oauth: OAuthConfig;
	isDefaultEnabled: boolean;
	isDeprecated?: boolean;
	status: ClientStatus;
	createdAt?: Date;
	updatedAt?: Date;
};

class Client {
	constructor(public _: ClientProps) {}

	static fromJson(json: any): Client {
		return new Client({
			id: json.id,
			slug: json.slug,
			displayName: json.display_name || json.displayName,
			description: json.description,
			logoUrl: json.logo_url || json.logoUrl,
			oauth: {
				authUrl: json.oauth.auth_url || json.oauth.authUrl,
				tokenUrl: json.oauth.token_url || json.oauth.tokenUrl,
				scopes: json.oauth.scopes || [],
				clientId: json.oauth.client_id || json.oauth.clientId,
				redirectUri: json.oauth.redirect_uri || json.oauth.redirectUri,
			},
			isDefaultEnabled: json.is_default_enabled ?? json.isDefaultEnabled ?? false,
			isDeprecated: json.is_deprecated ?? json.isDeprecated ?? false,
			status: json.status || ClientStatus.ACTIVE,
			createdAt: json.created_at ? new Date(json.created_at) : undefined,
			updatedAt: json.updated_at ? new Date(json.updated_at) : undefined,
		});
	}

	toJson() {
		return {
			id: this._.id,
			slug: this._.slug,
			display_name: this._.displayName,
			description: this._.description,
			logo_url: this._.logoUrl,
			oauth: {
				auth_url: this._.oauth.authUrl,
				token_url: this._.oauth.tokenUrl,
				scopes: this._.oauth.scopes,
				client_id: this._.oauth.clientId,
				redirect_uri: this._.oauth.redirectUri,
			},
			is_default_enabled: this._.isDefaultEnabled,
			is_deprecated: this._.isDeprecated,
			status: this._.status,
			created_at: this._.createdAt,
			updated_at: this._.updatedAt,
		};
	}
}

interface ClientsCatalogProps {
	clients: Client[];
}

class ClientsCatalog {
	constructor(private _: ClientsCatalogProps) {}

	get clients() {
		return this._.clients;
	}

	findById(id: string): Client | undefined {
		return this.clients.find((client) => client._.id === id);
	}

	findBySlug(slug: string): Client | undefined {
		return this.clients.find((client) => client._.slug === slug);
	}

	activeClients(): Client[] {
		return this.clients.filter(
			(client) => client._.status === ClientStatus.ACTIVE && !client._.isDeprecated
		);
	}
}

export { Client, ClientsCatalog };
export type { ClientProps, OAuthConfig };
